import { SOFTWARES_SUPPORTED_FOR_AP_VIEW } from 'routes/BudgetModule/config/softwareSupport';
import { ApOperationsT } from './Operations/types';
import { ApT } from './types';

export const datesFromPayload = (entry: ApT | ApOperationsT): number[] =>
    Array.from(
        new Set(
            Object.keys(entry)
                // @ts-expect-errorTODO StrictNullCheck not that easy to remove
                .map((key: string) => parseInt(key.split('..').pop(), 10))
                .filter((maybeYear) => !Number.isNaN(maybeYear))
                .sort(),
        ),
    );

export const isApViewSupported = (
    softwares: Set<string>,
    demoSoftware: string | undefined,
) => {
    // demo software is used on `presentation` server, based on an extra_feature. It allows
    // the Manty user to fake different finance softwares for the demo. As we only support
    // AP for Ciril, we want to hide it when faking other softwares because it raises false expectations.
    if (demoSoftware && demoSoftware.toLowerCase() !== 'ciril_finances')
        return false;
    return SOFTWARES_SUPPORTED_FOR_AP_VIEW.some((soft) => softwares.has(soft));
};
